export function openLinkInNewTab(path: string): void {
  const baseUrl = "https://produtos.lex.com.br";
  const fullUrl = `${baseUrl}/${path}`;
  window.open(fullUrl, "_blank");
}
